<div class="panel-group" id="accordion">
  <app-report-detail-section [section]="'description'" [title]="'Description'" [allExpandState]="allExpandState">
  </app-report-detail-section>
  <div #section id="description" class="panel-collapse collapse">
    <div class="panel-body ">
      <app-aa-spinner [loading]="isLoading"></app-aa-spinner>
      @if (!isLoading) {
        <div>
          @for (reportDescription of description | SortByTimeStampPipe : 'CreateDate'; track reportDescription) {
            <div class="desc">
              <label class="description-timestamp">{{reportDescription.createDate | date:'MM/dd/yyyy'}} at
              {{reportDescription.createDate | date:'shortTime'}}</label>
              <label class="description-text"> {{reportDescription.narrativeText}}</label>
            </div>
          }
          @if (!description.length > 0) {
            <label> No Description Provided</label>
          }
          @if (hideAddButton) {
            <app-add-section-inline [title]="'Add description'" [btnTitle]="'Save'"
            (onSave)="onSave($event)"> </app-add-section-inline>
          }
        </div>
      }
    </div>
  </div>
</div>
